"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UFOVehicleDetailsForm = void 0;
var react_1 = __importStar(require("react"));
var Form_1 = require("./Form");
/**
 * The Urban Fleet Order Vehicle Details Form serves as a simple way by which Urban Fleet
 * Order-relevant Asset information can be viewed, added, or edited.
 *
 * The `UFOVehicleDetailsForm` requires the `UFOVehicleDetailsFormContext`.
 * Therefore, it should always be wrapped by a `UFOVehicleDetailsFormProvider`.
 */
var UFOVehicleDetailsForm = react_1.forwardRef(function (props, ref) {
    var onSubmit = props.onSubmit, onValidationFailed = props.onValidationFailed, defaultValues = props.defaultValues, readOnly = props.readOnly, mode = props.mode, onDirtyStateChanged = props.onDirtyStateChanged, getTireSize = props.getTireSize, hideDetails = props.hideDetails, getCustomTireSize = props.getCustomTireSize, optionalTireSizes = props.optionalTireSizes;
    return (react_1.default.createElement(Form_1.UFOForm, { onSubmit: onSubmit, onValidationFailed: onValidationFailed, onDirtyStateChanged: onDirtyStateChanged, defaultValues: defaultValues, readOnly: readOnly, mode: mode, ref: ref, formDefinition: {}, getTireSize: getTireSize, getCustomTireSize: getCustomTireSize, hideDetails: hideDetails, optionalTireSizes: optionalTireSizes }));
});
exports.UFOVehicleDetailsForm = UFOVehicleDetailsForm;
//# sourceMappingURL=UFOVehicleDetailsForm.js.map